export const getUniques = (arr: string[]): string[] => {
  return [...new Set([...arr])];
};
